import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import moment from 'moment';
import { withStyles  } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import Checkbox from '@mui/material/Checkbox';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Lock from '@mui/icons-material/Lock';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { toCurrency } from '../../utils/currency';

const styles = theme => ({
  keys: {
    fontWeight: 700,
    flex: '0 1 auto',
    width: 175
  },
  values: {
    marginLeft: 50
  },
  lock: {
    color: theme.palette.grey[500]
  },
  selected: {
    '&$selected': {
      backgroundColor: theme.palette.primary.light
    }
  }
});

class SourceSettings extends Component {

  parseValue = (placement, field) => {
    if (field.hasMany) {
      return this.getMany(placement[field.propName]);
    }
    if (field.displayProp) {
      return get(placement, field.displayProp);
    }
    return this.format(placement[field.propName], field);
  };

  format = (value, field) => {
    switch (field.formatValue) {
      case 'boolean':
        return this.toBoolean(value);
      case 'date':
        return this.toDate(value);
      case 'currency':
        return toCurrency(value);
      default:
        return value;
    }
  };

  toDate = value => {
    return moment(value).format('YYYY-MM-DD');
  };

  toBoolean = value => {
    if (value === false) return 'NO';
    if (value === true) return 'YES';
    return value;
  };

  getMany = value => {
    if (!value) return '';
    return value.map(v => {
      return <Chip key={v.name} label={v.name} />
    });
  };

  render() {
    const { classes, fields, placement, checked, onCheck } = this.props;

    return (
      <Grid container spacing={0}>

        <Grid item xs={12}>
          <List>
            {fields.map((f /* , idx */) => {
            const value = this.parseValue(placement, f);

            return (
              <div key={f.propName}>
                <ListItemButton
                  dense
                  selected={!!checked[f.propName]}
                  classes={{
                    selected: classes.selected
                  }}
                  disabled={!value}
                  onClick={onCheck(f.propName, f)}
                >
                  <Checkbox
                    color="primary"
                    style={{ width: 32, height: 32 }}
                    icon={<CheckBoxOutlineBlankIcon style={{ fontSize: 24 }} />}
                    checkedIcon={<CheckBoxIcon style={{ fontSize: 24 }} />}
                    checked={!!checked[f.propName]}
                    disableRipple
                  />
                  <ListItemText
                    className={classes.keys}
                    classes={{ primary: classes.keys }}
                    primary={f.displayName}
                  />
                  <ListItemText
                    className={classes.values}
                    primary={value || 'N/A'}
                  />
                  { f.lockedWhenLive && <Lock className={classes.lock} /> }
                </ListItemButton>
                <Divider />
              </div>
            )}
          )}
          </List>
        </Grid>
      </Grid>
    )
  }
}

SourceSettings.propTypes = {
  classes: PropTypes.object.isRequired,
  fields: PropTypes.arrayOf(PropTypes.object).isRequired,
  checked: PropTypes.object.isRequired,
  onCheck: PropTypes.func.isRequired,
  placement: PropTypes.object.isRequired
};

export default withStyles(styles)(SourceSettings);
